module.exports = __webpack_public_path__ + "img/counseling-banner-jan.2cfe57e4.webp";